import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  selectPrefix,
  selectWidth,
  selectreportFromDate,
  selectreportToDate,
  setreportsFromDate,
  setreportsTodate,
} from "../../../utility/Redux/profile";
import { FromToDate } from "../../../utility/component/fromToDate";
import { GetSaleSummary } from "./func";
import { selectToken } from "../../../utility/Redux/security";
import { SummaryColumns } from "./columns";
import Footer from "./footer";
import { useReactToPrint } from "react-to-print";
import GeniusTableReports from "../../../utility/component/geniusComponents/geniusTableData";
import IsLocalData from "../../../utility/component/isLocalData";
import FromToDateMobile from "../../../utility/component/fromToDateMobile";
import GeniusTableForReports from "../../../utility/component/printReport";
import { Pagination } from "@mui/material";

const TrialBalanceAccountPage = () => {
  const prefix = useSelector(selectPrefix);
  const [summaryList, setSummaryList] = useState([]);
  const fromDate = useSelector(selectreportFromDate);
  const ToDate = useSelector(selectreportToDate);
  const width = useSelector(selectWidth);
  const printRef = useRef(null);
  const [filterType, setFilterType] = useState("");
  const [voucherNo, setVoucherNo] = useState("");
  const columns = SummaryColumns(width);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const okButton = (page) => {
    GetSaleSummary(
      {
        table_prefix: prefix,
        FDATE: moment(fromDate).format("YYYY-MM-DD"),
        TDATE: moment(ToDate).format("YYYY-MM-DD"),
        page: page ? page : currentPage,
      },
      token,
      dispatch,
      setSummaryList,
      setTotalPages,
      setCurrentPage
    );
  };
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    pageStyle: `
  @page {
    size: portrait;
  }
`,
  });

  useEffect(() => {
    const callback = (details, data) => {
      setSummaryList(data);
      dispatch(setreportsFromDate(details[0].FDATE));
      dispatch(setreportsTodate(details[0].TDATE));
    };
    const elseFunc = () => {};
    IsLocalData("trial_balance_account_head_wise", callback, elseFunc);
  }, []);
  const difrence = summaryList[0]
    ? summaryList.reduce((acc, row) => acc + Number(row.DEBIT), 0) -
      summaryList.reduce((acc, row) => acc + Number(row.CREDIT), 0)
    : 0;

  return (
    <div className=" bg-white flex flex-col h-full overflow-y-auto   ">
      <div className=" flex flex-col h-full p-3 ">
        <div className="font-semibold pb-2">
          Trial Balance - Account Head Wise
        </div>
        <div>
          {window.innerWidth <= 700 ? (
            <>
              <FromToDateMobile
                onPrintClick={handlePrint}
                submit={() => {
                  okButton();
                }}
              />
            </>
          ) : (
            <FromToDate
              hideReset={true}
              onPrintClick={handlePrint}
              submit={() => {
                okButton();
              }}
              otherButton={
                <div className="flex text-sm items-center border-l pl-2">
                  <div className="text-red-500 font-semibold">
                    Show Debit/Credit
                  </div>
                  <select
                    onChange={(e) => {
                      setFilterType(e.target.value);
                    }}
                    value={filterType}
                    className="ml-3 outline-none border bg-[#e6e6e3] rounded-sm py-1"
                  >
                    <option value={""}>Both</option>
                    <option value={"Credit"}>Credit Only</option>
                    <option value={"Debit"}>Debit Only</option>
                  </select>
                </div>
              }
              reset={() => {
                setSummaryList([]);
              }}
            />
          )}
        </div>

        {summaryList[0] ? (
          <div
            style={{
              height: `calc(100% - 180px)`,
              width: "100%",
              marginTop: 10,
            }}
            className=" mb-2  "
          >
            <GeniusTableReports
              data={summaryList.filter((s) => {
                if (filterType) {
                  return filterType === "Credit"
                    ? s.CREDIT > 0
                    : filterType === "Debit"
                    ? s.DEBIT > 0
                    : false;
                } else {
                  return true;
                }
              })}
              columns={columns}
              pagination={
                <div
                  style={{
                    width: columns.reduce(
                      (acc, row) => acc + Number(row.width),
                      0
                    ),
                  }}
                  className="flex justify-end mt-1"
                >
                  {" "}
                  <Pagination
                    onChange={(e, v) => {
                      okButton(v);
                    }}
                    count={totalPages}
                    page={currentPage}
                  />{" "}
                </div>
              }
              footer={<Footer columns={columns} rows={summaryList} />}
            />
            <div className="w-full mt-3 ">
              <div
                style={{
                  display: "none",
                }}
              >
                <div ref={printRef}>
                  <div>
                    <GeniusTableForReports
                      customeHeader={
                        <div className="items-center  ">
                          <div className="flex flex-col items-center">
                            <div className="mr-1 text-sm font-semibold flex justify-center ">
                              Trial balance - Account Head Wise
                            </div>
                            <div className="flex">
                              <div className="text-sm font-semibold">
                                From :
                              </div>
                              <div className="ml-1 text-sm">
                                {moment(fromDate).format("DD-MM-YYYY")}{" "}
                              </div>
                              <div className="text-sm font-semibold ml-2">
                                To :
                              </div>
                              <div className="ml-1 text-sm">
                                {moment(ToDate).format("DD-MM-YYYY")}{" "}
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      data={summaryList}
                      columns={columns}
                      marginTop={"120px"}
                      headerWidth={true}
                      Fotter={
                        <div className=" w-full ">
                          <div className="flex justify-start text-sm flex-1">
                            <div className="flex items-center ">
                              <div className=" mr-2 font-bold w-[110px] text-[15px] ">
                                Total Debit
                              </div>
                              :
                              <div className="ml-1 text-[15px] text-right font-semibold">
                                {summaryList.reduce(
                                  (acc, row) => acc + Number(row.DEBIT),
                                  0
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="flex justify-start text-sm flex-1">
                            <div className="flex items-center ">
                              <div className=" mr-2 font-bold w-[110px]  text-[15px] ">
                                Total Credit
                              </div>
                              :
                              <div className="ml-1 text-[15px]  text-right font-semibold">
                                {summaryList.reduce(
                                  (acc, row) => acc + Number(row.CREDIT),
                                  0
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="flex justify-start text-sm flex-1">
                            <div className="flex items-center ">
                              <div className=" mr-2 font-bold w-[110px]  text-[15px] text-red-500">
                                Diffrence
                              </div>
                              :
                              <div className="ml-1 text-[15px]  text-right font-semibold">
                                {difrence.toFixed(2)}
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="h-full flex justify-center items-center text-sm text-gray-400 border mt-3 rounded-sm">
            No Records Found
          </div>
        )}

        {difrence > 0 && (
          <div
            style={{
              width: columns.reduce((acc, row) => acc + Number(row.width), 0),
            }}
            className="flex justify-between text-sm"
          >
            <div className="flex items-center ">
              <div className=" mr-2 font-bold  text-[18px] ">Total Records</div>
              :
              <div className="ml-1 text-[18px]  text-right font-semibold">
                {summaryList.length}
              </div>
            </div>
            <div className="flex items-center ">
              <div className=" mr-2 font-bold text-[18px] text-red-500">
                Diffrence
              </div>
              :
              <div className="ml-1 text-[18px]  text-right font-semibold">
                {difrence.toFixed(2)}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TrialBalanceAccountPage;
